import * as type from "../types/new-list";

const initialState = {
  apiUrl: null,
  listSize: {
    status: null,
    loading: true,
    error: null,
  },
  listFilter: {
    registrationFrom: null,
    registrationTo: null,
    employeesFrom: null,
    employeesTo: null,
    organizationType: null,
    isVatRegistered: null,
    inBusinessRegister: null,
    inFoundationRegister: null,
    locations: [],
    industryCodes: [],
  },
  createList: {
    status: null,
    loading: false,
    error: null,
  },
};

export const newList = (state = initialState, payload) => {
  switch (payload.type) {
    case type.SET_FILTER_REGISTRATION_FROM:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          registrationFrom: payload.date,
        },
      };
    case type.RESET_FILTER_REGISTRATION_FROM:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          registrationFrom: null,
        },
      };
    case type.SET_FILTER_REGISTRATION_TO:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          registrationTo: payload.date,
        },
      };
    case type.RESET_FILTER_REGISTRATION_TO:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          registrationTo: null,
        },
      };
    case type.SET_FILTER_EMPLOYEES_FROM:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          employeesFrom: payload.amount,
        },
      };
    case type.RESET_FILTER_EMPLOYEES_FROM:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          employeesFrom: null,
        },
      };
    case type.SET_FILTER_EMPLOYEES_TO:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          employeesTo: payload.amount,
        },
      };
    case type.RESET_FILTER_EMPLOYEES_TO:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          employeesTo: null,
        },
      };
    case type.SET_FILTER_ORGANIZATION_TYPE:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          organizationType: payload.selection,
        },
      };
    case type.RESET_FILTER_ORGANIZATION_TYPE:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          organizationType: null,
        },
      };
    case type.SET_FILTER_IS_VAT_REGISTERED:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          isVatRegistered: payload.selection,
        },
      };
    case type.RESET_FILTER_IS_VAT_REGISTERED:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          isVatRegistered: null,
        },
      };
    case type.SET_FILTER_IN_BUSINESS_REGISTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          inBusinessRegister: payload.selection,
        },
      };
    case type.RESET_FILTER_IN_BUSINESS_REGISTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          inBusinessRegister: null,
        },
      };
    case type.SET_FILTER_IN_FOUNDATION_REGISTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          inFoundationRegister: payload.selection,
        },
      };
    case type.RESET_FILTER_IN_FOUNDATION_REGISTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          inFoundationRegister: null,
        },
      };
    case type.APPEND_LOCATION_FILTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          locations: [...state.listFilter.locations, payload.selection],
        },
      };
    case type.RESET_APPEND_LOCATION_FILTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          locations: [],
        },
      };
    case type.REMOVE_LOCATION_FILTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          locations: [
            ...state.listFilter.locations.filter(
              (code) => code !== payload.selection
            ),
          ],
        },
      };
    case type.RESET_REMOVE_LOCATION_FILTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          locations: [],
        },
      };
    case type.REQUEST_LIST_SIZE:
      return {
        ...state,
        listSize: {
          ...state.listSize,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_LIST_SIZE:
      return {
        ...state,
        listSize: {
          ...state.listSize,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.SET_LIST_SIZE:
      return {
        ...state,
        listSize: {
          ...state.listSize,
          status: payload.size,
          loading: false,
          error: null,
        },
      };
    case type.RESET_LIST_SIZE:
      return {
        ...state,
        listSize: {
          ...state.listSize,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.APPEND_INDUSTRY_CODE_FILTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          industryCodes: [...state.listFilter.industryCodes, payload.selection],
        },
      };
    case type.RESET_APPEND_INDUSTRY_CODE_FILTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          industryCodes: [],
        },
      };
    case type.REMOVE_INDUSTRY_CODE_FILTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          industryCodes: [
            ...state.listFilter.industryCodes.filter(
              (code) => code !== payload.selection
            ),
          ],
        },
      };
    case type.RESET_REMOVE_INDUSTRY_CODE_FILTER:
      return {
        ...state,
        listFilter: {
          ...state.listFilter,
          industryCodes: [],
        },
      };
    case type.REQUEST_ADD_NEW_LIST:
      return {
        ...state,
        createList: {
          ...state.createList,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_ADD_NEW_LIST:
      return {
        ...state,
        createList: {
          ...state.createList,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_ADD_NEW_LIST:
      return {
        ...state,
        createList: {
          ...state.createList,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_ADD_NEW_LIST:
      return {
        ...state,
        createList: {
          ...state.createList,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.RESET_API_URL:
      return {
        ...state,
        apiUrl: null,
      };
    case type.SET_API_URL:
      return {
        ...state,
        apiUrl: payload.url,
      };
    case type.RESET_LIST_INPUT:
      return {
        ...state,
        apiUrl: null,
        listFilter: {
          registrationFrom: null,
          registrationTo: null,
          employeesFrom: null,
          employeesTo: null,
          organizationType: null,
          isVatRegistered: null,
          inBusinessRegister: null,
          inFoundationRegister: null,
          locations: [],
          industryCodes: [],
        },
      };
    default:
      return state;
  }
};
